import groupChatApi from '../api/groupChatApi';
import ChatRoom from '../models/chatRoom';
import User from '../models/user';
import UserApi from '../api/userApi';
import DailyFreeOpeningHours from '../models/DailyFreeOpeningHours';
import GroupChatInvite from '../models/groupChatInvite';
import moment from 'moment';
import { ChatRoomAuthorized } from 'redhotpie-shared-lib/models/authorizedChatroom';

class groupChatService {
  getGroupsChat() {
    return groupChatApi.getGroupsChat().then(res => {
      let data = [];

      try {
        if (res.success) {
          data = ChatRoom.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: groupChatService/getGroupsChat:', res.message);
        }
        return { success: res.success, data };
      } catch (e) {
        console.log('ERROR: groupChatService/getGroupsChat:', e);
        throw new Error('failed');
      }
    });
  }

  getGroupChatMembers(params) {
    return UserApi.getProfileSummariesDetails(params).then(res => {
      let data = [];

      try {
        if (res.success) {
          data = User.mappingObjectsCustom(res.data.items);
        } else {
          console.log('ERROR: groupChatService/getGroupsChat:', res.message);
        }
        return data;
      } catch (e) {
        console.log('ERROR: groupChatService/getGroupsChat:', e);
        throw new Error('failed');
      }
    });
  }

  updateUserStatus(xmppId, params) {
    return groupChatApi.updateUserStatus(xmppId, params).then(res => {
      try {
        if (res.success) {
          return res.data;
        }
      } catch (e) {
        console.log('ERROR: groupChatService/updateUserStatus:', e);
        throw new Error('failed');
      }
      return res;
    });
  }

  getListUsersStatus(params, roomJid) {
    return groupChatApi.getListUsersStatus(params, roomJid).then(res => {
      try {
        if (res.success) {
          return { success: true, items: res.data.obj };
        }
      } catch (e) {
        console.log('ERROR: groupChatService/getListUsersStatus:', e);
        throw new Error('failed');
      }
      return res;
    });
  }

  getChatRoomAuthorized() {
    return groupChatApi.getChatRoomAuthorized().then(res => {
      let data = {};
      try {
        if (res.success) {
          data = ChatRoomAuthorized.mappingObject(res.data);
        } else {
          console.log('ERROR: groupChatService/getChatRoomAuthorized:', res.message);
        }
        return { success: res.success, data };
      } catch (e) {
        console.log('ERROR: groupChatService/getChatRoomAuthorized:', e);
        throw new Error('failed');
      }
    });
  }

  createUserChatroomBan(params, userBanedId) {
    return groupChatApi.createUserChatroomBan(params, userBanedId).then(res => {
      try {
        if (res.success) {
          // data = ChatRoom.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: groupChatService/createUserChatroomBan:', res.message);
        }
        return { success: res.success, data: res.data };
      } catch (e) {
        console.log('ERROR: groupChatService/createUserChatroomBan:', e);
        throw new Error('failed');
      }
    });
  }

  getNoteBanChatroom(params, userBanedId) {
    return groupChatApi.getNoteBanChatroom(params, userBanedId).then(res => {
      // let data = [];
      // console.log("getNoteBanChatroom",res);

      try {
        if (res.success) {
          // data = ChatRoom.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: groupChatService/getNoteBanChatroom:', res.message);
        }
        return { success: res.success, data: res.data };
      } catch (e) {
        console.log('ERROR: groupChatService/getNoteBanChatroom:', e);
        throw new Error('failed');
      }
    });
  }

  postNoteBanChatroom(params, userBanedId) {
    return groupChatApi.postNoteBanChatroom(params, userBanedId).then(res => {
      // let data = [];
      // console.log("postNoteBanChatroom",res);

      try {
        if (res.success) {
          // data = ChatRoom.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: groupChatService/postNoteBanChatroom:', res.message);
        }
        return { success: res.success, data: res.data };
      } catch (e) {
        console.log('ERROR: groupChatService/postNoteBanChatroom:', e);
        throw new Error('failed');
      }
    });
  }

  getFreeHoursChatRoom() {
    return groupChatApi.getFreeHoursChatRoom().then(res => {
      try {
        if (res.success && res.data) {
          return {
            success: res.success,
            data: DailyFreeOpeningHours.mappingObject(res.data),
          };
        }
        console.log('ERROR: groupChatService/getFreHoursChatRoom:', res.message);
        return { success: false, message: res.message };
      } catch (e) {
        console.log('ERROR: groupChatService/getFreHoursChatRoom:', e);
        return { success: false, message: e };
      }
    });
  }

  postJoinGroupSuccess(roomJid, shareToken = '') {
    return groupChatApi.postJoinGroupSuccess(roomJid, shareToken).then(res => {
      try {
        if (res.success && res.data) {
          // console.log("postJoinGroupSuccess", roomJid, res)
          return { success: true, data: res.data, statusCode: res.statusCode };
          // return {success: res.success, data: DailyFreeOpeningHours.mappingObject(res.data)};
        }
        console.log('ERROR: groupChatService/postJoinGroupSuccess:', res.data.message);
        return { success: false, message: res.data.message, statusCode: res.data.statusCode };
      } catch (e) {
        console.log('ERROR: groupChatService/postJoinGroupSuccess:', e);
        return { success: false, message: e };
      }
    });
  }

  postLeaveGroupSuccess(roomJid) {
    return groupChatApi.postLeaveGroupSuccess(roomJid).then(res => {
      try {
        if (res.success && res.data) {
          return { success: false, data: res.data };
          // return {success: res.success, data: DailyFreeOpeningHours.mappingObject(res.data)};
        }
        console.log('ERROR: groupChatService/postLeaveGroupSuccess:', res.message);
        return { success: false, message: res.message };
      } catch (e) {
        console.log('ERROR: groupChatService/postLeaveGroupSuccess:', e);
        return { success: false, message: e };
      }
    });
  }

  checkUserInRooms(params) {
    return groupChatApi.postSignalCheckInRoom(params).then(res => {
      try {
        if (res.success && res.data) {
          // console.log("send check in room success", res);
        } else {
          console.log('ERROR: groupChatService/getFreHoursChatRoom:', res.message);
          // return {success: false, message: res.message};
        }
      } catch (e) {
        console.log('ERROR: groupChatService/getFreHoursChatRoom:', e);
        // return {success: false, message: e};
      }
    });
  }

  getGroupsCanBeInvited(userId) {
    return groupChatApi.getGroupsCanBeInvited(userId).then(res => {
      try {
        return { ...res, data: GroupChatInvite.mappingObjects(res.data.items) };
      } catch (e) {
        console.log('ERROR: groupChatService/getGroupsCanBeInvited:', e);
        return { success: false, message: e };
      }
    });
  }

  getGroupChatMember(roomJid, userId) {
    return groupChatApi.getGroupChatMember(roomJid, userId).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: groupChatService/getGroupChatMember:', e);
        return { success: false, message: e };
      }
    });
  }

  getCurrentGroupChatMemberStatus(roomJid) {
    return groupChatApi.getCurrentGroupChatMemberStatus(roomJid).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: groupChatService/getCurrentGroupChatMemberStatus:', e);
        return { success: false, message: e };
      }
    });
  }

  sendGroupsChatInvite(roomJid, userId) {
    return groupChatApi.sendGroupsChatInvite(roomJid, userId).then(res => {
      // console.log(res, roomJid, userId)
      try {
        if (res.success && res.data) {
          return { success: true, data: res.data };
        }
        console.log('ERROR: groupChatService/sendGroupsChatInvite:', res.message);
        return { success: false, message: res.message };
      } catch (e) {
        console.log('ERROR: groupChatService/sendGroupsChatInvite:', e);
        return { success: false, message: e };
      }
    });
  }

  getGroupChatMessageStatus() {
    return groupChatApi.getGroupChatMessageStatus().then(res => {
      try {
        if (res.success && res.data) {
          let _messageBanExpiry = 0;
          let _photoBanExpiry = 0;
          if (res.data.SendMessageBanExpiry) {
            const exp = moment(res.data.SendMessageBanExpiry);
            const now = moment();
            _messageBanExpiry = Math.round(exp.diff(now) / 1000 / 60);
          }
          if (res.data.SendPhotoBanExpiry) {
            const exp = moment(res.data.SendPhotoBanExpiry);
            const now = moment();
            _photoBanExpiry = Math.round(exp.diff(now) / 1000 / 60);
          }
          return {
            success: true,
            data: {
              sendMessageBan: res.data.SendMessageBan,
              sendMessageBanExpiry: _messageBanExpiry,
              sendPhotoBan: res.data.SendPhotoBan,
              sendPhotoBanExpiry: _photoBanExpiry,
            },
          };
        }
        console.log('ERROR: groupChatService/getGroupChatMessageStatus:', res.message);
        return { success: false, message: res.message };
      } catch (e) {
        console.log('ERROR: groupChatService/getGroupChatMessageStatus:', e);
        return { success: false, message: e };
      }
    });
  }

  revokeGroupToken(roomJid) {
    return groupChatApi.revokeGroupToken(roomJid).then(res => {
      try {
        if (res.success && res.data) {
          return { success: false, data: res.data };
        }
        return { success: false, message: res.message };
      } catch (e) {
        console.log('ERROR: groupChatService/postLeaveGroupSuccess:', e);
        return { success: false, message: e };
      }
    });
  }

  getGroupChatDetail(roomJid) {
    return groupChatApi.getGroupChatDetail(roomJid).then(res => {
      try {
        if (res.success && res.data) {
          return { success: false, data: res.data };
        }
        return { success: false, message: res.message };
      } catch (e) {
        console.log('ERROR: groupChatService/getGroupChatDetail:', e);
        return { success: false, message: e };
      }
    });
  }

  setChatRoomReminder(roomId) {
    return groupChatApi.setChatRoomReminder(roomId).then(res => {
      return { success: res.success, message: res.message };
    });
  }

  deleteChatRoomReminder(roomId) {
    return groupChatApi.deleteChatRoomReminder(roomId).then(res => {
      return { success: res.success, message: res.message };
    });
  }
}

export default new groupChatService();
